import { useEffect, useState } from "react";
import {
  getIbAccountQueryParams,
  IB_ACTIVE_ACCOUNT_CHANGED_EVENT,
} from "../Constants/accountTypes";
import {
  normalizeAccountBalanceData,
  pickPrimaryBalanceCents,
} from "./Normalizers";
import useCallAxios from "./useCallAxios";

const filterQuery = (values = {}) => ({ ...values });

export const useAccountBalanceData = () => {
  // GET /v1/ib/accounts/balances → BaaS BalanceList (primary BRL picked client-side).
  const context = `accountBalance`;
  const [balanceValue, setBalanceValue] = useState(0);
  const [spendableValue, setSpendableValue] = useState(0);
  const { reset, requestSuccess, requestData, requestLoading, fetchGET } =
    useCallAxios({
      context,
    });
    
  const { data } = requestData;

  const handleGET = (params = {}) => {
    const accountId = params.account_id ?? params.accountId;
    const rest = { ...params };
    delete rest.account_id;
    delete rest.accountId;
    fetchGET({
      context,
      queryParameters: filterQuery({
        ...rest,
        ...getIbAccountQueryParams(accountId),
      }),
    });
  };

  useEffect(() => {
    const onActiveAccountChanged = (event) => {
      if (
        typeof window !== "undefined"
        && String(window.location.pathname || "").startsWith("/baas")
      ) {
        return;
      }
      handleGET({ account_id: event?.detail?.accountId });
    };
    window.addEventListener(IB_ACTIVE_ACCOUNT_CHANGED_EVENT, onActiveAccountChanged);
    return () => {
      window.removeEventListener(IB_ACTIVE_ACCOUNT_CHANGED_EVENT, onActiveAccountChanged);
    };
    // fetchGET identity is not stable.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Axios response → body; some proxies nest again under data.data.
  const payload =
    data?.data && (data.data.items || Array.isArray(data.data))
      ? data.data
      : data;
  const state = normalizeAccountBalanceData({ data: payload });

  useEffect(() => {
    if (!!payload) {
      const flat = pickPrimaryBalanceCents(payload);
      setBalanceValue(flat.balance);
      setSpendableValue(
        Number.isFinite(flat.spendable) ? flat.spendable : flat.balance,
      );
    }
  }, [payload]);

  return {
    reset,
    loading: requestLoading,
    state,
    balanceValue,
    spendableValue,
    success: requestSuccess,
    handleGET,
    accountId: payload?.account_id || payload?.accountId || payload?.AccountId || null,
    raw: payload,
  };
};
